import { createElement } from "react";
const Circle = (p) => createElement("circle", p);
const ClipPath = (p) => createElement("clipPath", p);
const Defs = (p) => createElement("defs", p);
const Ellipse = (p) => createElement("ellipse", p);
const ForeignObject = (p) => createElement("foreignObject", p);
const G = (p) => createElement("g", p);
const Image = (p) => createElement("image", p);
const Line = (p) => createElement("line", p);
const LinearGradient = (p) => createElement("linearGradient", p);
const Marker = (p) => createElement("marker", p);
const Mask = (p) => createElement("mask", p);
const Path = (p) => createElement("path", p);
const Pattern = (p) => createElement("pattern", p);
const Polygon = (p) => createElement("polygon", p);
const Polyline = (p) => createElement("polyline", p);
const RadialGradient = (p) => createElement("radialGradient", p);
const Rect = (p) => createElement("rect", p);
const Shape = (p) => createElement("shape", p);
const Stop = (p) => createElement("stop", p);
const Svg = (p) => createElement("svg", p);
const Symbol = (p) => createElement("symbol", p);
const Text = (p) => createElement("text", p);
const TextPath = (p) => createElement("clipPath", p);
const TSpan = (p) => createElement("tSpan", p);
const Use = (p) => createElement("use", p);
var src_default = {
  Circle,
  ClipPath,
  Defs,
  Ellipse,
  ForeignObject,
  G,
  Image,
  Line,
  LinearGradient,
  Marker,
  Mask,
  Path,
  Pattern,
  Polygon,
  Polyline,
  RadialGradient,
  Rect,
  Shape,
  Stop,
  Svg,
  Symbol,
  Text,
  TextPath,
  TSpan,
  Use
};
export {
  Circle,
  ClipPath,
  Defs,
  Ellipse,
  ForeignObject,
  G,
  Image,
  Line,
  LinearGradient,
  Marker,
  Mask,
  Path,
  Pattern,
  Polygon,
  Polyline,
  RadialGradient,
  Rect,
  Shape,
  Stop,
  Svg,
  Symbol,
  TSpan,
  Text,
  TextPath,
  Use,
  src_default as default
};
//# sourceMappingURL=index.js.map
